import { render, staticRenderFns } from "./ReminderAlert.vue?vue&type=template&id=07da43b0&scoped=true&"
import script from "./ReminderAlert.vue?vue&type=script&lang=js&"
export * from "./ReminderAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07da43b0",
  null
  
)

export default component.exports